<template>
  <section class="container page-py" dir="ltr">
    <div
      class="bread-crumbs"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      <div
        class="navigate-info"
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
      >
        <nuxt-link
          to="/blog"
          class="navigate-info-route"
          itemprop="item"
        >
          <meta itemprop="position" content="1" />
          {{ $t('Blog') }} </nuxt-link
        ><span class="navigate-info__arrow">></span
        ><span class="navigate-info__span" itemprop="name">{{
          $t('artTitle26')
        }}</span
        ><meta itemprop="position" content="2" />
      </div>
    </div>
    <h1>{{ $t('artTitle26') }}</h1>
    <p>{{ $t('artText26-1') }}</p>
    <img
      :src="`${staticUrl}/images/blog/3D_Interior_Design_Dive_Into_New_World_with_This_App.webp`"
      :alt="'altImageDefault'"
    />
    <h2>{{ $t('artText26-2') }}</h2>
    <p>{{ $t('artText26-3') }}</p>
    <h2>{{ $t('artText26-4') }}</h2>
    <p>{{ $t('artText26-5') }}</p>
    <h2>{{ $t('artText26-6') }}</h2>
    <p>{{ $t('artText26-7') }}</p>
    <h2>{{ $t('artText26-8') }}</h2>
    <p>{{ $t('artText26-9') }}</p>
    <h2>{{ $t('artText26-10') }}</h2>
    <p>{{ $t('artText26-11') }}</p>
    <img
      :src="`${staticUrl}/images/blog/3D_Interior_Design_Dive_Into_New_World_with_This_App_1.webp`"
      :alt="'altImageDefault'"
    />
    <h2>{{ $t('artText26-12') }}</h2>
    <p>{{ $t('artText26-13') }}</p>
  </section>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const {t} = useI18n();

useSeoMeta({
  title: `${t('artSeoTitle26')}`,
  ogTitle: `${t('artSeoTitle26')}`,
  description: `${t('artSeoDesc26')}`,
  ogDescription: `${t('artSeoDesc26')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
  twitterCard: 'summary_large_image',
});
</script>

<style scoped lang="scss">
@import 'css/blog/blog';
</style>
